var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlluNoNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 347,
    viewBox: "0 0 674 347",
    width: 674,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m306.319 179.031h-244.319v-130.031h244.319z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m306.027 49.875h-243.1525v30.9043h243.1525z",
    fill: "#ededed"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m306.319 179.031h-244.319v-130.031h244.319zm-242.5697-1.749h240.8197v-126.5327h-240.8197z",
    fill: "#b4b8b8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ededed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m172.224 106.557c-1.155.004-2.09 1.504-2.087 3.351.002 1.841.935 3.333 2.087 3.337h98.611c1.155-.004 2.089-1.504 2.087-3.351-.002-1.841-.936-3.333-2.087-3.337z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.224 125.935c-1.155.003-2.09 1.503-2.087 3.35.002 1.842.935 3.334 2.087 3.337h98.611c1.155-.003 2.089-1.503 2.087-3.35-.002-1.842-.936-3.334-2.087-3.337z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.224 145.077c-1.155.003-2.09 1.503-2.087 3.35.002 1.842.935 3.334 2.087 3.337h42.432c1.156-.003 2.09-1.503 2.088-3.35-.002-1.842-.936-3.334-2.088-3.337z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.156 155.666c14.778 0 26.758-11.98 26.758-26.759 0-14.778-11.98-26.759-26.758-26.759-14.779 0-26.7593 11.981-26.7593 26.759 0 14.779 11.9803 26.759 26.7593 26.759z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m597.285 179.031h-244.318v-130.031h244.318z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m596.994 49.875h-243.153v30.9043h243.153z",
    fill: "#ededed"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m597.285 179.031h-244.318v-130.031h244.318zm-242.569-1.749h240.82v-126.5327h-240.82z",
    fill: "#b4b8b8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ededed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m463.191 106.557c-1.155.004-2.09 1.504-2.088 3.351.003 1.841.936 3.333 2.088 3.337h98.61c1.155-.004 2.09-1.504 2.088-3.351-.003-1.841-.936-3.333-2.088-3.337z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m463.191 125.935c-1.155.003-2.09 1.503-2.088 3.35.003 1.842.936 3.334 2.088 3.337h98.61c1.155-.003 2.09-1.503 2.088-3.35-.003-1.842-.936-3.334-2.088-3.337z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m463.191 145.077c-1.155.003-2.09 1.503-2.088 3.35.003 1.842.936 3.334 2.088 3.337h42.432c1.155-.003 2.09-1.503 2.087-3.35-.002-1.842-.935-3.334-2.087-3.337z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.122 155.666c14.779 0 26.759-11.98 26.759-26.759 0-14.778-11.98-26.759-26.759-26.759-14.778 0-26.759 11.981-26.759 26.759 0 14.779 11.981 26.759 26.759 26.759z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m484.424 306.476h-309.563v-164.755h309.563z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m484.055 142.829h-308.085v39.157h308.085z",
    fill: "#ed7226"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m484.424 306.476h-309.563v-164.755h309.563zm-307.346-2.216h305.13v-160.323h-305.13z",
    fill: "#252f54"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m314.52 214.649c-1.463.005-2.647 1.905-2.645 4.245.003 2.334 1.186 4.224 2.645 4.229h124.944c1.464-.005 2.648-1.906 2.645-4.246-.003-2.333-1.185-4.223-2.645-4.228z",
    fill: "#ededed"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m314.52 239.2c-1.463.005-2.647 1.906-2.645 4.245.003 2.334 1.186 4.224 2.645 4.229h124.944c1.464-.005 2.648-1.905 2.645-4.245-.003-2.334-1.185-4.224-2.645-4.229z",
    fill: "#ededed"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m314.52 263.455c-1.463.005-2.647 1.905-2.645 4.245.003 2.334 1.186 4.224 2.645 4.229h53.764c1.463-.005 2.648-1.905 2.645-4.245-.003-2.334-1.186-4.224-2.645-4.229z",
    fill: "#ededed"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m251.081 276.872c18.725 0 33.905-15.18 33.905-33.905s-15.18-33.905-33.905-33.905-33.904 15.18-33.904 33.905 15.179 33.905 33.904 33.905z",
    fill: "#ededed"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluNoNotes);
export default __webpack_public_path__ + "static/media/illu-no_notes.a389f71cbf13c7242dd1b6be3739be19.svg";
export { ForwardRef as ReactComponent };